export default "__VITE_ASSET__GCYvpfIY__"